// src/pages/PrivacyPolicy.jsx
import React from 'react';
import SEO from '../components/SEO';
import '../index.css';

const PrivacyPolicy = () => {
  return (
    <>
      <SEO
        title="Privacy Policy - RapidMind AI Data Protection"
        description="Learn how RapidMind AI protects your privacy and handles your data. Our comprehensive privacy policy covers data collection, usage, security, and your rights."
        keywords="privacy policy, data protection, rapidmind ai privacy, user data security, GDPR compliance, data rights"
        image="/RapidMind 2025.png"
        type="website"
      />
      <div className="privacy-container">
        <h1 className="privacy-title">RapidMind AI Privacy Policy</h1>
        <p className="privacy-updated">Last updated: July 24, 2025</p>

      <section>
        <h2>1. Introduction</h2>
        <p>
          RapidMind AI is committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your personal information when you use our services.
        </p>
      </section>

      <section>
        <h2>2. Information We Collect</h2>
        <ul>
          <li>Account data (email, username, password)</li>
          <li>Chat interactions for AI improvement (if consented)</li>
          <li>Payment and subscription information</li>
          <li>Usage and device data</li>
        </ul>
      </section>

      <section>
        <h2>3. How We Use Your Information</h2>
        <p>We use the data to:</p>
        <ul>
          <li>Deliver AI responses</li>
          <li>Improve our AI performance</li>
          <li>Provide customer support</li>
          <li>Analyze usage to improve our platform</li>
        </ul>
      </section>

      <section>
        <h2>4. Data Sharing & Security</h2>
        <p>
          We do not sell your personal data. Your information may be shared with trusted partners (e.g., payment providers). We use industry-standard encryption and security protocols.
        </p>
      </section>

      <section>
        <h2>5. Your Rights</h2>
        <p>
          You have the right to access, update, or delete your data. Contact us if you wish to exercise these rights.
        </p>
      </section>

      <section>
        <h2>6. Contact Us</h2>
        <p>
          If you have any questions about this policy, please contact us at <a href="mailto:support@rapidmind.ai">support@rapidmind.ai</a>.
        </p>
      </section>

      <div className="privacy-checkbox" style={{ marginTop: '1rem' }}>
        <input
          type="checkbox"
          id="acceptPrivacy"
          required
          style={{ marginRight: '0.5rem' }}
        />
        <label htmlFor="acceptPrivacy">
          I have read and accept the{' '}
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>.
        </label>
      </div>
    </div>
    </>
  );
};

export default PrivacyPolicy;
